import { IPage } from '@/types/AppTypes';
import { httpRequest } from '@/utils/HttpRequest';
import {
	IPurchasesSearch,
	IPurchaseDetail,
	IPurchasesInsert,
	IPurchasesUpdate,
	IPurchaseExamine,
} from './purchasesTypes';
import { ISettleParams } from '../public/publicService';
import { ISaleSettlement } from '../sales/salesTypes';

class PurchasesService {
	async page(searchVo: IPurchasesSearch, config: object = {}) {
		const apiUrl = '/gtm/purchase/listPage';
		return await httpRequest.post<IPage<IPurchaseDetail>>(apiUrl, searchVo, config);
	}
	async one(id: string) {
		const apiUrl = `/gtm/purchase/findByIdOrCode/${id}`;
		return await httpRequest.get<IPurchaseDetail>(apiUrl);
	}
	async insert(insertVo: IPurchasesInsert) {
		const apiUrl = '/gtm/purchase/insert';
		return await httpRequest.post<string>(apiUrl, insertVo);
	}
	async update(updateVo: IPurchasesUpdate) {
		const apiUrl = '/gtm/purchase/update';
		return await httpRequest.post<string>(apiUrl, updateVo);
	}
	//作废
	async disable(id: string) {
		const apiUrl = `/gtm/purchase/disable/${id}`;
		return await httpRequest.get<boolean>(apiUrl);
	}
	// 总监审核
	async examineManager(Vo: IPurchaseExamine) {
		const apiUrl = '/gtm/purchase/examineManager';
		return await httpRequest.post<boolean>(apiUrl, Vo);
	}
	// 财务审核
	async examineReckoner(Vo: IPurchaseExamine) {
		const apiUrl = '/gtm/purchase/examineReckoner';
		return await httpRequest.post<boolean>(apiUrl, Vo);
	}
	// 提交审核
	async submitPurchase(id: string) {
		const apiUrl = `/gtm/purchase/submit/${id}`;
		return await httpRequest.get<boolean>(apiUrl);
	}
	//入库
	async whConfirm(vo: { "code": string, "shopCode": string }) {
		const apiUrl = `/gtm/purchase/whConfirm`;
		return await httpRequest.post<boolean>(apiUrl, vo)
	}
	//采购合同明细导出
	async exportDetails(vo: { "code": string, "shopCode": string }) {
		const apiUrl = `/gtm/purchase/exportDetails`;
		return await httpRequest.postFile<boolean>(apiUrl, vo)
	}
	//结算
	async settle(settleVo: ISettleParams) {
		const apiUrl = `/gtm/purchase/settle`;
		return await httpRequest.post<boolean>(apiUrl, settleVo);
	}

	//导出
	async export(searchVo: IPurchasesSearch) {
		const appPageUrl = '/gtm/purchase/export';
		return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
	}

	//下载模板
	async downloadTpl() {
		const appPageUrl = '/gtm/purchase/downloadTpl';
		return await httpRequest.getFile(appPageUrl);
	}

	//结算完结
	async settleStatu(code: string) {
		const apiUrl = `/gtm/purchase/settle/${code}`;
		return await httpRequest.get<boolean>(apiUrl);
	}
	//结算
	async receiptSettle(settleVo: ISaleSettlement[]) {
		const apiUrl = `/gtm/receipt/settle`;
		return await httpRequest.post<boolean>(apiUrl, settleVo);
	}
	//结算分页查询
	async receiptPage(searchVo: any) {
		const apiUrl = `/gtm/receipt/search/pg`;
		return await httpRequest.post<IPage<ISaleSettlement>>(apiUrl, searchVo);
	}
	   // 修改审批时间
	   offerTime(updateVo: any){
        const apiUrl = `/gtm//audit/update`
        return   httpRequest.post<string>(apiUrl, updateVo);
    }
}

export const purchasesService = new PurchasesService();
